class MediaCentreRender {
    static customRender(item)
    {
        item.tags = [];
        if (item.url) {
            var bioURL = new URL(item.url)
            item.relativeURL = bioURL.pathname;
        }
        if (item.recordObj.hasOwnProperty("expertCategoryObj")) {
            let tags = item.recordObj.expertCategoryObj;
            if (Array.isArray(tags)) {
                tags.forEach(function(tag){
                    // convert camel case tag into title case display tag
                    let displayTagRaw = tag.replace(/([A-Z])/g, " $1");
                    let displayTag = displayTagRaw.charAt(0).toUpperCase() + displayTagRaw.slice(1);
                    item.tags.push({
                        color: 'dark-blue',
                        title: displayTag,
                        tag: tag,
                    });
                })
            }
        }
        return item;
    }
}

export default MediaCentreRender;